import { Wrapper } from "../Wrapper";
import { Container } from "./styles";

export function Footer() {
  return (
    <Container>
      <Wrapper color="white">
        <a href="mailto:markstm10@gmail.com">markstm10@gmail.com</a>
      </Wrapper>

      <p>
        In development by <strong>Marcos Paulo</strong> - 2023
      </p>
    </Container>
  );
}
